import React from 'react'

const PlusIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    fill="none"
    viewBox="0 0 22 22"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M11 3v8H3M19 11h-8v8"
    ></path>
  </svg>
)

export default PlusIcon
